import RequestAbstract from "../abstract";

export default class PublicCurrencyRateSources extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-currency-rate-sources";
    }

}
